import { useRef } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const amount = 320;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -amount : amount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section id="categories" className="w-full bg-background-100 py-20 md:py-28">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-1">
                Explorar{' '}
                <span className="text-accent-600">Categorias</span>
              </h2>
              <p className="text-foreground-500 text-sm">
                14 categorias de produtos verificados — encontre o que precisa em segundos
              </p>
            </div>
            <div className="flex items-center gap-3">
              <span className="px-4 py-1.5 bg-foreground-950 text-background-50 text-xs font-semibold rounded-full whitespace-nowrap">
                14 Categorias
              </span>
              <button
                onClick={() => scroll('left')}
                className="w-9 h-9 rounded-full border border-foreground-200 flex items-center justify-center text-foreground-600 hover:bg-foreground-950 hover:text-white hover:border-foreground-950 transition-all cursor-pointer"
              >
                <i className="ri-arrow-left-s-line text-lg"></i>
              </button>
              <button
                onClick={() => scroll('right')}
                className="w-9 h-9 rounded-full border border-foreground-200 flex items-center justify-center text-foreground-600 hover:bg-foreground-950 hover:text-white hover:border-foreground-950 transition-all cursor-pointer"
              >
                <i className="ri-arrow-right-s-line text-lg"></i>
              </button>
            </div>
          </div>

          {/* Scrollable cards */}
          <div
            ref={scrollRef}
            className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide snap-x snap-mandatory"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {categories.map((cat) => (
              <a
                key={cat.seq}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="flex-shrink-0 w-[260px] snap-start group cursor-pointer"
              >
                <div className="bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02]">
                  <div className="h-52 overflow-hidden">
                    <img
                      src={cat.image}
                      alt={`${cat.namePt} - CSSBuy Spreadsheet categoria`}
                      title={`${cat.namePt} - Produtos verificados CSSBuy`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-5">
                    <p className="text-base font-semibold text-foreground-950 mb-1">{cat.namePt}</p>
                    <p className="text-xs text-foreground-500">{cat.name}</p>
                    <div className="mt-3 flex items-center justify-between">
                      <span className="text-xs text-accent-600 font-medium">Ver produtos</span>
                      <i className="ri-arrow-right-up-line text-accent-500 text-sm"></i>
                    </div>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}